import API from 'services/TAPS_API';

export default function submitOD(data) {
  return API.request({
    method: 'POST',
    url: '/notification/1150076/submit',
    data,
  });
}
